/**
 * Records that the advisor opened the prospect list (once per visit) and opened a prospect's panel
 * (once per prospect opened), for PRD §14's weekly-open and engagement measures.
 */
import { useEffect, useRef } from 'react';
import type { Prospecting } from '@client/api/types';
import { trackProspectListOpened, trackProspectPanelOpened } from '../lib/analytics';

export function useProspectsAnalytics(modelVersion: string | undefined, openDetail: Prospecting.ProspectDetail | undefined) {
  const listTracked = useRef(false);
  const lastPanel = useRef<string | null>(null);

  useEffect(() => {
    if (!modelVersion || listTracked.current) return;
    listTracked.current = true;
    trackProspectListOpened(modelVersion);
  }, [modelVersion]);

  useEffect(() => {
    if (!openDetail || !modelVersion || lastPanel.current === openDetail.prospectId) return;
    lastPanel.current = openDetail.prospectId;
    trackProspectPanelOpened(openDetail.tier, modelVersion);
  }, [openDetail, modelVersion]);
}
